// import React from "react";
// import image from "../../../Assets/Images/About.png";

// const Hero = () => {
//   return (
//     <div className="mx-auto px-6 lg:px-14 py-16 flex flex-col lg:flex-row items-center gap-12">
//       <div className="relative w-full lg:w-1/2">
//         <div className="absolute -left-2 -bottom-2 md:-bottom-4 md:-left-4 w-full h-full bg-primaryColor rounded-xl -z-10"></div>
//         <img
//           src={image}
//           alt="INSD Mentorship"
//           className="w-full h-auto rounded-xl object-cover"
//         />
//       </div>

//       <div className="flex-1 space-y-6 text-left">
//         <h2 className="text-5xl font-bold font-barlow leading-tight">
//           Nurturing Creative Minds for a Global Design Future
//         </h2>
//         <p className="text-gray-600 text-lg leading-relaxed">
//           At{" "}
//           <span className="font-semibold">
//             INSD – International School of Design
//           </span>
//           , we believe that every creative idea deserves expert guidance. Our
//           mentors — top designers, artists, and industry professionals — ensure
//           that students gain the skills, confidence, and exposure they need to
//           excel in the world of design.
//         </p>

//         <ul className="space-y-3 text-base md:text-lg text-gray-700">
//           <li className="flex items-center gap-3">
//             <div className="bg-black w-4 h-4 rounded-sm">
//               <span className="w-4 h-4 bg-primaryColor -translate-y-1 -translate-x-1 rounded-sm block"></span>
//             </div>
//             Learn directly from award-winning designers and creative
//             professionals
//           </li>
//           <li className="flex items-center gap-3">
//             <div className="bg-black w-4 h-4 rounded-sm">
//               <span className="w-4 h-4 bg-primaryColor -translate-y-1 -translate-x-1 rounded-sm block"></span>
//             </div>
//             Gain real-world experience through live industry projects and
//             workshops
//           </li>
//           <li className="flex items-center gap-3">
//             <div className="bg-black w-4 h-4 rounded-sm">
//               <span className="w-4 h-4 bg-primaryColor -translate-y-1 -translate-x-1 rounded-sm block"></span>
//             </div>
//             Access mentorship and career guidance from leading fashion & design
//             experts
//           </li>
//         </ul>

//         <button className="relative w-1/2 md:w-1/3 bg-gradient-to-r from-primaryColor to-secondaryColor text-white font-bold rounded-xl py-4 overflow-hidden group transition-all duration-300">
//           <span className="block transition-transform duration-500 ease-in-out group-hover:-translate-y-10">
//             Our Mentors
//           </span>
//           <span className="absolute inset-0 flex items-center justify-center translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-in-out">
//             Our Mentors
//           </span>
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Hero;

import React, { useEffect } from "react";
import { Sparkles, Award, TrendingUp, Users } from "lucide-react";
import image from "../../../Assets/Images/About.png";
import AOS from "aos";
import "aos/dist/aos.css";
// import useEffect from "react";

const Hero = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 50,
      delay: 0,
      easing: "ease-out",
      disable: "mobile",
    });
    AOS.refresh();
  }, []);
  return (
    <div className="relative mt-8 lg:mt-20 mb-12 px-4 md:px-6 lg:px-14 w-full mx-auto overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-[#DA3335]/5 to-transparent rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-[#144982]/5 to-transparent rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative  flex flex-col lg:flex-row-reverse items-start justify-between gap-8 lg:gap-12">
        {/* Right Content Section */}
        <div
          data-aos="fade-left"
          className="w-full lg:w-1/2  space-y-6 lg:space-y-6 "
        >
          {/* Main Heading */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-extrabold leading-tight bg-gradient-to-r from-gray-900 via-[#DA3335] to-[#144982] bg-clip-text text-transparent heading">
              Nurturing Creative Minds for a Global Design Future
            </h2>
            <div className="mt-4 w-20 h-1.5 bg-gradient-to-r from-[#DA3335] to-[#144982] rounded-full"></div>
          </div>

          {/* Description */}
          <p className="text-base md:text-lg lg:text-xl font-normal leading-relaxed text-gray-700 sub-heading tracking-wide">
            At{" "}
            <span className="font-bold bg-gradient-to-r from-[#DA3335] to-[#144982] bg-clip-text text-transparent heading">
              INSD – International School of Design
            </span>
            , we believe that every creative idea deserves expert guidance. Our
            mentors — top designers, artists, and industry professionals —
            ensure that students gain the skills, confidence, and exposure they
            need to excel in the world of design.
          </p>

          {/* Feature Points */}
          <div className="space-y-2 sub-heading">
            <div className="group flex items-start gap-4 p-2 rounded-xl bg-white border-2 border-gray-200 hover:border-[#DA3335] hover:shadow-lg transition-all duration-300">
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#DA3335]/10 to-[#144982]/10 rounded-lg flex items-center justify-center group-hover:bg-gradient-to-br group-hover:from-[#DA3335] group-hover:to-[#144982] transition-all duration-300">
                <Award
                  className="text-[#DA3335] group-hover:text-white transition-colors duration-300"
                  size={22}
                />
              </div>
              <p className="text-base md:text-lg text-gray-700 group-hover:text-gray-900 transition-colors duration-300 tracking-wide">
                Learn directly from award-winning designers and creative
                professionals.
              </p>
            </div>

            <div className="group flex items-start gap-4 p-2 rounded-xl bg-white border-2 border-gray-200 hover:border-[#DA3335] hover:shadow-lg transition-all duration-300">
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#DA3335]/10 to-[#144982]/10 rounded-lg flex items-center justify-center group-hover:bg-gradient-to-br group-hover:from-[#DA3335] group-hover:to-[#144982] transition-all duration-300">
                <TrendingUp
                  className="text-[#DA3335] group-hover:text-white transition-colors duration-300"
                  size={22}
                />
              </div>
              <p className="text-base md:text-lg text-gray-700 group-hover:text-gray-900 transition-colors duration-300 tracking-wide">
                Gain real-world experience through live industry projects and
                workshops.
              </p>
            </div>

            <div className="group flex items-start gap-4 p-2 rounded-xl bg-white border-2 border-gray-200 hover:border-[#DA3335] hover:shadow-lg transition-all duration-300">
              <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#DA3335]/10 to-[#144982]/10 rounded-lg flex items-center justify-center group-hover:bg-gradient-to-br group-hover:from-[#DA3335] group-hover:to-[#144982] transition-all duration-300">
                <Users
                  className="text-[#DA3335] group-hover:text-white transition-colors duration-300"
                  size={22}
                />
              </div>
              <p className="text-base md:text-lg text-gray-700 group-hover:text-gray-900 transition-colors duration-300 tracking-wide">
                Access mentorship and career guidance from leading fashion &
                design experts.
              </p>
            </div>
          </div>
        </div>

        {/* Left Image Section - FIXED */}
        {/* Left Image Section with top badge */}
        <div
          data-aos="fade-right"
          className="w-full lg:w-1/2 flex flex-col items-center lg:items-start gap-4"
        >
          {/* Badge on top of left section */}
          {/* <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#DA3335]/10 to-[#144982]/10 border border-[#DA3335]/20 rounded-full px-4 py-2 shadow-sm">
            <Sparkles size={16} className="text-[#DA3335]" />
            <span className="text-sm font-semibold text-gray-700">
              Excellence in Design Education
            </span>
          </div> */}

          {/* Image container below */}
          <div className="relative group w-full">
            {/* Gradient Background Blur */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#DA3335] to-[#144982] rounded-2xl blur-sm group-hover:blur-md transition-all duration-500"></div>

            {/* Main Image Container */}
            <div className="relative bg-gradient-to-br from-[#DA3335] to-[#144982] rounded-2xl p-1.5 z-10">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={image}
                  alt="INSD Mentorship"
                  className="w-full h-auto md:h-[590px] object-cover rounded-2xl transform group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              </div>
            </div>

            {/* Floating Badges */}
            <div className="absolute top-6 right-6 bg-white rounded-xl shadow-2xl px-5 py-3 border border-gray-100 animate-float z-20">
              <div className="flex items-center gap-3">
                <div className="md:w-12 md:h-12 bg-gradient-to-br from-[#DA3335] to-[#144982] rounded-lg flex items-center justify-center">
                  <Award className="text-white" size={24} />
                </div>
                <div>
                  <p className="text-base md:text-2xl font-extrabold text-gray-900 heading">
                    50+
                  </p>
                  <p className="text-xs text-gray-600 sub-heading">
                    Expert Mentors
                  </p>
                </div>
              </div>
            </div>

            <div className="absolute bottom-6 left-6 bg-white rounded-xl shadow-2xl px-5 py-3 border border-gray-100 animate-float-delayed z-20">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-[#144982] to-[#DA3335] rounded-lg flex items-center justify-center">
                  <Users className="text-white" size={24} />
                </div>
                <div>
                  <p className="text-base md:text-2xl font-extrabold text-gray-900 heading">
                    5000+
                  </p>
                  <p className="text-xs text-gray-600 sub-heading">
                    Alumni Network
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        @keyframes float-delayed {
          0%,
          100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-12px);
          }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        .animate-float-delayed {
          animation: float-delayed 3s ease-in-out infinite 0.5s;
        }
      `}</style>
    </div>
  );
};

export default Hero;
